<template>
  <div class="follow_up_mode">
    <div class="data_top">
      <div class="right"> 
        <el-button @click="addFollow">添加跟进方式</el-button>
      </div>
    </div>
    <el-table
        class="table"
        :data="data.list"
        :header-cell-style="{background:'rgb(249,249,249)'}"
        ref="multipleTable"
        :row-style="{height: '40px'}"
        style="width: 99%;margin: 0 auto">
      <el-table-column
          prop="name"
          align="left"
          label="跟进方式">
      </el-table-column>
      <el-table-column
          prop="describe"
          align="center"
          label="方式描述">
      </el-table-column>
      <el-table-column
          align="center"
          label="操作">
        <template v-slot="scope">
          <span style="color: var(--themeColors);font-size: 14px; cursor: pointer;" @click="editFollow(scope.row)">编辑</span>
          <span @click="open_del_dialog(scope.row.id)" style="color: rgb(249, 104, 104);font-size: 14px; cursor: pointer;margin-left: 10px">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn_right">
      <div style="float: right">
        <el-pagination
            background
            layout="total,sizes, prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-sizes="[20, 50, 100, 200, 500]"
            :page-size="data.pagesize"
            :pager-count='5'
            @size-change="type_modify_page"
            @current-change="type_switch_page"
            :total="data.total">
        </el-pagination>
      </div>
    </div>

    <Dialog :show.sync="add_show" :name_width="add_dialog" class="plan_dialog">
      <span slot="body">
        <el-form class="demo-form-inline" label-position="right" label-width="100px">
          <el-form-item label="跟进方式：">
            <el-input
                type="text"
                style="width: 300px;"
                placeholder="跟进方式名称"
                v-model="followForm.name"
                maxlength="6"
                show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="方式描述：">
            <el-input
                type="textarea"
                style="width: 300px;"
                placeholder="请输入内容"
                v-model="followForm.describe"
                rows="5"
                maxlength="100"
                resize="none"
                show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </span>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary"  @click="add_save">保 存</el-button>
        <el-button @click="add_close">取 消</el-button>
      </div>
    </Dialog>

    <Dialog :show.sync="edit_show" :name_width="edit_dialog" class="plan_dialog">
      <span slot="body">
        <el-form class="demo-form-inline" label-position="right" label-width="100px">
          <el-form-item label="跟进方式：">
            <el-input
                type="text"
                style="width: 300px;"
                placeholder="跟进方式名称"
                v-model="followForm.name"
                maxlength="6"
                show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item label="方式描述：">
            <el-input
                type="textarea"
                style="width: 300px;"
                placeholder="请输入内容"
                v-model="followForm.describe"
                rows="5"
                maxlength="100"
                resize="none"
                show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </span>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary"  @click="edit_save">保 存</el-button>
        <el-button @click="edit_close">取 消</el-button>
      </div>
    </Dialog>

    <!--    删除弹窗-->
    <Dialog :show.sync="del_show" :name_width="del_dialog" class="dialog">
      <span slot="body">
        <p>确定删除这个字段吗？</p>
      </span>
      <div slot="footer">
        <el-button type="primary"  @click="save_del_dialog">确 定</el-button>
        <el-button @click="close_del_dialog">取 消</el-button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import {getCustomerFollowUpList, addCustomerFollowUp, editCustomerFollowUp, delCustomerFollowUp} from 'network/hk_customer'

import Dialog from "components/content/dialog/Dialog";
import Sortable from "sortablejs";
import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'
export default {
  name: "FollowUpMode",
  components: {
    Dialog
  },
  data() {
    return {
		is_powerAdd: false,
		is_powerEdit: false,
		is_powerDel: false,
		is_powerImp: false,
		is_powerExp: false,
		is_powerRec: false,
		
      add_show: false,
      add_dialog: {
        name: '添加字段',
        width: '500px'
      },
      edit_show: false,
      edit_dialog: {
        name: '编辑字段',
        width: '500px'
      },
      // 删除弹窗
      del_show: false,
      del_dialog: {
        name: '删除字段',
        width: '300px'
      },
      del_id: null,


      data: {
        pagesize: 20,
        page: 1,
        total: 0,
        list: [],
      },

      followForm: {
        name: '',
        describe: ''
      }
    }
  },
  created() {
	  this.judgePower()
    this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
  },
  methods: {
	  judgePower() {
	  	this.is_powerAdd = retupower('247')
	  	this.is_powerEdit = retupower('248')
	  	this.is_powerDel = retupower('249')
	  	this.is_powerImp = retupower('250')
	  	this.is_powerExp = retupower('251')
	  	this.is_powerRec = retupower('252')
	  },
    // 新建弹窗
    addFollow() {
		if(retujudpower(this.is_powerAdd)) {
			this.followForm = {
			  id: '',
			  name: '',
			  describe: ''
			}
			this.add_show = true
		}
     
    },
    add_save() {
      this.addCustomerFollowUp(2, this.followForm.name, this.followForm.describe)
    },
    add_close() {
      this.add_show = false
    },
    // 编辑弹窗
    editFollow(row) {
		if(retujudpower(this.is_powerEdit)) {
			this.followForm.id = row.id
			this.followForm.name = row.name
			this.followForm.describe = row.describe
			this.edit_show = true
		}
     
    },
    edit_save() {
      this.editCustomerFollowUp(this.followForm.id, this.followForm.name, this.followForm.describe)
    },
    edit_close() {
      this.edit_show = false
    },

    // 删除弹窗
    open_del_dialog(id) {
		if(retujudpower(this.is_powerDel)) {
			this.del_id = id
			this.del_show = true
		}
     
    },
    save_del_dialog() {
      this.delCustomerFollowUp(this.del_id)
    },
    close_del_dialog() {
      this.del_show = false
    },

    // 切换页码
    type_modify_page(val) {
      this.data.pagesize = val
      this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
    },
    type_switch_page(val) {
      this.data.page = val
      this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
    },

    // 获取跟进方式列表
    getCustomerFollowUpList(type, pagesize, page) {
      getCustomerFollowUpList(type, pagesize, page).then(res => {
        if (res.code === 10000) {
          this.data.list = res.result.data
          this.data.total = res.result.total
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 添加跟进方式
    addCustomerFollowUp(type, name, describe) {
      addCustomerFollowUp(type, name, describe).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '添加成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
          this.add_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 编辑跟进方式
    editCustomerFollowUp(id, name, describe) {
      editCustomerFollowUp(id, name, describe).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '编辑成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
          this.edit_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
    // 编辑跟进方式
    delCustomerFollowUp(id) {
      delCustomerFollowUp(id).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '删除成功',
            type: 'success',
            offset: 100
          });
          this.getCustomerFollowUpList(2, this.data.pagesize, this.data.page)
          this.del_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.follow_up_mode {
  width: 100%;
  height: auto;
  background: #fff;
}
.table {
  padding-top: 15px;
}

.data_top {
  width: 100%;
  height: 45px;
  margin-top: 10px;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}

.right>.el-button {
  height: 32px;
  padding: 10px 15px;
  background: var(--themeColors);
  color: #fff;
  border: none;
}
.right>.el-button:hover {
  background: var(--themeColorsHover);
}

.btn_right {
  height: 50px;
  margin-top: 15px;
  margin-right: 10px;
}
</style>